export default function () {
  return {
    title: [String, Number],
    value: [String, Number, Array],
    isLink: Boolean,
    link: [String, Object],
    arrowDirection: [String]
  }
}



// WEBPACK FOOTER //
// ./components/cell/props.js